/**
 * @generated SignedSource<<46852e0f390b9d046d5a4b0794089f0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavigationMenu_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavigationMenuClubCard_session" | "useGetTabBarItemsFragment_session">;
  readonly " $fragmentType": "NavigationMenu_session";
};
export type NavigationMenu_session$key = {
  readonly " $data"?: NavigationMenu_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationMenu_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavigationMenu_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetTabBarItemsFragment_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavigationMenuClubCard_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "b878e75538520dbdfdaf7d2f980bcc37";

export default node;
